<script setup lang="ts">
import { onMounted, watch } from "vue";
import zhCn from "element-plus/dist/locale/zh-cn.mjs";
import { useCorpOptionsStore } from "@app/store/modules/corpOptions";
import { useCurrentUserStore } from "@app/store/modules/currentUser";
import { useDfSellableStoreOptionsStore } from "@app/store/modules/dfSellableStoreOptions";
import { useStoreOptionsStore } from "@app/store/modules/storeOptions";
import { useAsyncTaskStore } from "@shared/store/modules/asyncTask";
import { useAuthStore } from "@shared/store/modules/auth";
// 副作用 import：注册仓库同步类异步任务的 handler，需在 restore() 之前就完成注册
import "@app/config/asyncTaskHandlers";

const auth = useAuthStore();
const corpOptionsStore = useCorpOptionsStore();
const currentUserStore = useCurrentUserStore();
const dfSellableStoreOptionsStore = useDfSellableStoreOptionsStore();
const storeOptionsStore = useStoreOptionsStore();
const asyncTaskStore = useAsyncTaskStore();

asyncTaskStore.configure({ basePath: "/manage" });

async function bootstrapSession() {
    await currentUserStore.fetchIfNeeded();
    asyncTaskStore.restore(currentUserStore.userDetail?.id);
    corpOptionsStore.fetchIfNeeded();
    storeOptionsStore.fetchIfNeeded();
    storeOptionsStore.fetchVcIfNeeded();
    storeOptionsStore.fetchWalmartDsvIfNeeded();
    dfSellableStoreOptionsStore.fetchIfNeeded();
}

function resetSession() {
    currentUserStore.reset();
    corpOptionsStore.reset();
    storeOptionsStore.reset();
    dfSellableStoreOptionsStore.reset();
}

onMounted(() => {
    if (auth.token) bootstrapSession();
});

watch(
    () => auth.token,
    token => {
        if (!token) resetSession();
        else bootstrapSession();
    },
);
</script>

<template>
    <el-config-provider :locale="zhCn">
        <router-view />
    </el-config-provider>
</template>
